module.exports = __webpack_public_path__ + "img/top_sensor_alert.740f886c.svg";